import { useContext, useMemo } from 'react'

import { isArray, isUndefined } from 'lodash'

import { GlobalContext } from '../../../Providers/GlobalProvider'
import { formatAsArray, getIdOrNull } from '../../../utils'
import EntitiesSelector from './EntitiesSelector'

const SectionToYearSelector = ({
  disabled, empty = false, highlightValues = [], multiple, style = {}, section, sectionToYears, values, placeholderOption = null,
  onChange
}) => {
  const gc = useContext(GlobalContext)

  const localSectionToYears = useMemo(() => {
    const localeValues = !isUndefined(sectionToYears) ? sectionToYears : gc.sectionToYearsBySection

    return isArray(localeValues) ? localeValues : formatAsArray(localeValues?.[getIdOrNull(section)])
  }, [sectionToYears, section, gc?.sectionToYearsBySection])

  const sectionToYearOptions = useMemo(() => localSectionToYears.map(sty => ({
    label: sty.schoolYearName,
    value: sty.id,
    tooltip: `${sty.sectionName} ${sty.schoolYearName ? '(' + sty.schoolYearName + ')' : ''}`,
    entity: sty
  })), [localSectionToYears])
  const toBeHighlighted = useMemo(() => highlightValues.map(sty => sty.id), [highlightValues])

  return (
    <EntitiesSelector
      disabled={disabled || !getIdOrNull(section)}
      entityOptions={sectionToYearOptions}
      highlightValues={toBeHighlighted}
      multiple={multiple}
      showSearch
      style={style}
      values={values}
      placeholderOption={placeholderOption}
      onChange={onChange}
      empty={empty}
    />
  )
}

export default SectionToYearSelector
